import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-kompetansetilskudd",
  templateUrl: "./kompetansetilskudd.component.html",
  imports: [FilterComponent, KpitabellComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class KompetansetilskuddComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Tilsagn";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForSoknad: string[] = [];
  grafIderForBelop: string[] = [];
  kpiListe: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. "],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Tilsagn: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt."],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Utbetaling: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt."],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "TILSK_BOLIGSOSIALT", false, true);
    this.qlikService.setFilter("TypeTilstand", "Tilsagn", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Tilskudd til boligsosiale tiltak - Husbanken");
    this.grafIderForSoknad = ["hvb-ant-saker", "hvb-ant-saker-pr-søkertype"];
    this.grafIderForBelop = ["hvb-belop", "hvb-belop-pr-søkertype"];
    this.kpiListe = ["HVB Antall saker", "HVB Beløp"];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    return this.typeTekst[this.statistikkType][this.graferValgt][0];
  }
}
